import type {Delimiter} from 'mdast'

import type {PositionedNode} from '../syntax-tree/positioned-node'

/** Returns the document-relative position of the delimiter excluding leading and trailing whitespace. */
export function trimmedDelimiterPosition(delimiter: Delimiter & PositionedNode): {
  startOffset: number
  endOffset: number
} {
  const raw = delimiter.raw
  const startIndex = raw.search(/\S/)
  const endIndex = raw.length - raw.trimEnd().length
  return {
    startOffset: delimiter.position.start.offset + startIndex,
    endOffset: delimiter.position.end.offset - endIndex,
  }
}
